import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

// Tick or un-tick the "already reviewed" marker on one row. The backend derives
// the storage key from the coordinates, so all four have to be sent — REF and ALT
// included, or two co-located variants would share one tick.
export const updateReviewedVariant = async (fileId, { chrom, pos, ref, alt }, reviewed) => {
  const { data } = await axios.post(`${API_BASE_URL}/reviewed-variants`, {
    fileId,
    chrom,
    pos,
    ref,
    alt,
    reviewed,
  })
  return data
}
